import { useClaimLab } from '../stores/claimLab'
import { abortNavigation, useNuxtApp } from '#imports'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!import.meta.client) {
    return
  }

  const { $auth0 } = useNuxtApp()
  const { isAuthenticated, getAccessTokenSilently } = $auth0()

  if (!isAuthenticated.value) {
    return abortNavigation()
  }

  const token = await getAccessTokenSilently()
  const currentUser = useCurrentUser()

  // Fetch user data if not already loaded
  if (!currentUser.value) {
    const userData = await $fetch('/api/claim-lab/auth-user', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    currentUser.value = (userData as any).data
  }

  const config = useRuntimeConfig().public
  const claimLabInfo = await $fetch(
    `/api/claim-lab/connector/${(to.params as any).connectorId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(config.WORKSPACE_ID
          ? {
              'x-rialtic-workspace-id': config.WORKSPACE_ID as string,
            }
          : {}),
      },
    },
  )

  if (!claimLabInfo.enabled) {
    return abortNavigation()
  }
  const claimLab = useClaimLab()

  claimLab.setWorkspaceId(claimLabInfo.workspaceId)
})
